import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  Layout,
  Drawer,
  Button,
  Input,
  Tooltip,
} from "antd";

import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DashboardOutlined,
  BarChartOutlined,
  CalendarOutlined,
  TeamOutlined,
  ReadOutlined,
  DollarOutlined,
  SettingOutlined,
  UsergroupAddOutlined,
  SearchOutlined,
  WalletOutlined,
  CreditCardOutlined,
  UserAddOutlined,
  SafetyCertificateOutlined,
  SolutionOutlined,
  ApartmentOutlined,
  BookOutlined,
  FileTextOutlined,
  FileSearchOutlined,
  PaperClipOutlined,
  CheckCircleOutlined,
  TrophyOutlined,
  LineChartOutlined,
  FileDoneOutlined,
  PieChartOutlined,
  IdcardOutlined,
  AccountBookOutlined,
  CheckSquareOutlined,
  CloseOutlined,
  PlusOutlined,
  MessageOutlined,
  CloudUploadOutlined,
} from "@ant-design/icons";

import {
  FaClipboardList,
  FaReceipt,
  FaGraduationCap,
  FaChalkboardTeacher,
} from "react-icons/fa";

import { motion } from "framer-motion";

// Financial
import SchoolFinancialReport from "../SchoolDashApp/SchoolFinancialReport";
import IncomeStatement from "../SchoolDashApp/IncomeStatement";
import SchoolFeeDataChart from "../SchoolDashApp/SchoolFeeDataChart";

// Local Curriculum
import AllCurriculumLis from "./LocalLessonPlan/AllCurriculumLis";
import ViewCurriculums from "./LocalLessonPlan/ViewCurriculums";
import CurriculumPost from "./LocalLessonPlan/CurriculumPost";

// Smart ID Cards
import TeacherAttendanceScanner from "./SmartIDCardScaner/TeacherAttendanceScanner";
import TeacherSmartCardManagement from "./SmartIDCardScaner/TeacherSmartCardManagement";
import TeacherScannerDeviceManagement from "./SmartIDCardScaner/TeacherScannerDeviceManagement";
import TeacherSmartAttendanceDashboard from "./SmartIDCardScaner/TeacherSmartAttendanceDashboard";

// Todo
import PostTodoList from "./CalenderAndTodo/PostTodoList";

// Teachers
import PrintTestByClass from "../pages/Teachers/PrintTestByClass";
import ViewLessonPlan from "../pages/Teachers/ViewLessonPlan";

// Dashboard

import OverviewVpi from "./pages/OverviewVpi";

// User
import UserSearchBox from "../SchoolDashApp/UserDetails/UserSearchBox";
import UserDetailsPage from "../SchoolDashApp/UserDetails/UserDetailsPage";
import ProfileImage from "./ProfileImage";

// Students
import AddStudentsStaff from "./NewStudents/AddStudentsStaff";
import AdmissionForm from "./NewStudents/AdmissionForm/AdmissionForm";
import StudentAdmission from "./NewStudents/AdmissionForm/StudentAdmission";

// Results
import GradeDistribution from "../pages/Reportcard/GradeDistribution";
import ReportCard from "./ReportCard";
import PromotionDashboard from "./AcademyYearSelection/PromotionDashboard";

// Academic
import ClassViewList from "../SchoolDashApp/Class/ClassViewList";
import SubjectViewList from "../SchoolDashApp/Class/Subjects/SubjectViewList";

// Staff
import SupportStaff from "../pages/Teachers/SupportStaff";

// Attendance
import AttendanceRecord from "../pages/Attendance/AttendanceRecord";
import AttendanceData from "../pages/Attendance/AttendanceData";

// Finance
import FinanceDashboard from "../pages/FinancialReports/FinanceDashboard";
import HighAveragesPage from "../SchoolDashApp/ReportCard/HighAveragesPage";
import StudentStatusSummary from "../SchoolDashApp/StudentStatusSummary";
import PeriodReport from "../pages/Reportcard/PeriodReport";
import BulkTestScorePage from "../SchoolDashApp/ReportCard/BulkTestScorePage";
import TopStudentPerPeriod from "../SchoolDashApp/ReportCard/TopStudentPerPeriod";
import Loan from "../pages/FinancialReports/Loan";
import FinancialPaymentRecord from "../SchoolDashApp/FinancialPaymentRecord";
import OtherFee from "../pages/FinancialReports/OtherFee";
import PaymentRecord from "../SchoolDashApp/PaymentRecord";
import SchoolFeesData from "../SchoolDashApp/SchoolFeesData";
import OtherFeesPayment from "../SchoolDashApp/OtherFeesPayment";
import MonthlyFinancialRecord from "../pages/FinancialReports/MonthlyFinancialRecord";
import DashboardForExpenditure from "./DashboardForExpenditure";
import Payroll from "../pages/Teachers/Payroll";

// Teaching
import AssignmentView from "../pages/Teachers/AssignmentView";
import GetStudentNotes from "../pages/Teachers/GetStudentNotes";
import TestPraint from "../pages/Teachers/TestPraint";
import TestAttachmentView from "../SchoolDashApp/TestAttachmentView";

// Student services
import CertificateDashboard from "./certificate/CertificateDashboard";
import StudentsIDCard from "../pages/Students/IdCards/StudentsIDCard";
import DailyPaymentTransactionUpdate from "./pages/DailyPaymentTransactionUpdate";
import StudentPaymentHistory from "../SchoolDashApp/DailyTransaction/StudentPaymentHistory";

// Other
import SchoolArchiveDashboard from "./SchoolArchiveDashboard";
import Darkmode from "./Darkmode/Darkmode";
import NotificationIcon from "../components/ChatApp/NotificationIcon";
import Notice from "../components/ChatApp/Notice";
import ComplaintUnit from "../Dashboard/ComplaintUnit";
import NewBlackList from "./NewBlackList";

// Academic Year
import AddAcademyYear from "./AcademyYearSelection/AddAcademyYear";

// Grade Publication
import AdminPublishGradesPopup from "../SchoolDashApp/AdminPublishGradesPopup";

// Curriculum
import CurriculumAdminUpload from "./CurriculumAdminUpload";

import logo from "./zpa.png";

const { Header, Sider, Content } = Layout;

/* ============================================================
   DESIGN SYSTEM
============================================================ */

const COLORS = {
  navy: "#031B35",
  deepNavy: "#021426",
  navyBlue: "#062A4B",
  blue: "#063A6B",
  black: "#071018",

  gold: "#F6C944",
  goldLight: "#FFE58A",
  yellow: "#EFA81C",
  orange: "#C0750D",
  antique: "#CBA454",

  green: "#4FAE22",
  sky: "#0F6DAB",

  white: "#FFFFFF",
  softWhite: "#F7F9FC",
  gray: "#C4C7C7",

  page: "#F4F7F9",
  pureWhite: "#FFFFFF",
  text: "#142536",
  muted: "#6B7280",
  border: "#E0E7EC",
  soft: "#F7F9FA",

  shadow:
    "0 12px 35px rgba(6,42,75,.075)",
};

/* ============================================================
   MENU ITEMS
============================================================ */

const menuItems = [
  {
    key: "overview",
    icon: <DashboardOutlined />,
    label: "Dashboard",
  },
  {
    key: "studentsadmission",
    icon: <UsergroupAddOutlined />,
    label: "Students Admission",
  },
  {
    key: "admissionlist",
    icon: <TeamOutlined />,
    label: "Students List",
  },
  {
    key: "promotion",
    icon: <UserAddOutlined />,
    label: "Promotion",
  },
  {
    key: "studentscertificate",
    icon: <SafetyCertificateOutlined />,
    label: "Students Certificate",
  },
  {
    key: "studentsidcards",
    icon: <IdcardOutlined />,
    label: "Generate ID Cards",
  },
  {
    key: "complaintunit",
    icon: <IdcardOutlined />,
    label: "Manage Students Complain",
  },
  {
    key: "statusrecord",
    icon: <SolutionOutlined />,
    label: "Students Status Record",
  },
  {
    key: "classviewlist",
    icon: <ApartmentOutlined />,
    label: "Grade Classes",
  },
  {
    key: "subjectviewlist",
    icon: <BookOutlined />,
    label: "Subject ViewList",
  },

  {
    key: "viewlessonplan",
    icon: <FaChalkboardTeacher />,
    label: "View Teacher Lesson Plans",
  },
  {
    key: "supportstaff",
    icon: <TeamOutlined />,
    label: "Support Staff Data",
  },
  {
    key: "getteachernotes",
    icon: <FileTextOutlined />,
    label: "Teacher Notes",
  },
  {
    key: "testprint",
    icon: <FileSearchOutlined />,
    label: "Teacher Test",
  },
  {
    key: "printtestbyclass",
    icon: <FileDoneOutlined />,
    label: "Print Test By Class",
  },
  {
    key: "testattachmentview",
    icon: <PaperClipOutlined />,
    label: "Test File or Attachment",
  },
  {
    key: "studentsassignments",
    icon: <FaClipboardList />,
    label: "Students Assignments",
  },
  {
    key: "studentsnotes",
    icon: <ReadOutlined />,
    label: "Students Notes",
  },
  {
    key: "attendancerecord",
    icon: <CheckCircleOutlined />,
    label: "Attendance Record",
  },
  {
    key: "attendancedata",
    icon: <CalendarOutlined />,
    label: "Attendance Data",
  },
  {
    key: "gradedistribution",
    icon: <PieChartOutlined />,
    label: "Grades Distribution",
  },
  {
    key: "bulkgrades",
    icon: <FaChalkboardTeacher />,
    label: "Bulk Grades",
  },
  {
    key: "topstudents",
    icon: <TrophyOutlined />,
    label: "Top Students",
  },
  {
    key: "highaverages",
    icon: <LineChartOutlined />,
    label: "High Yearly Averages",
  },
  {
    key: "periodicreport",
    icon: <FileDoneOutlined />,
    label: "Periodic Report",
  },
  {
    key: "reportcard",
    icon: <FileTextOutlined />,
    label: "Report Card",
  },
  {
    key: "schoolarchivedashboard",
    icon: <FaChalkboardTeacher />,
    label: "School Archive Dashboard",
  },
  {
    key: "teachersmartattendancedashboard",
    icon: <FaChalkboardTeacher />,
    label: "Monitor Teacher Attendance",
  },
];


/* ============================================================
   NAVIGATION SECTIONS
============================================================ */

const navigationSections = [
  {
    key: "command",
    title: "COMMAND CENTER",
    items: ["overview", "analytics"],
  },
  {
    key: "finance",
    title: "FINANCE & OPERATIONS",
    items: [
      "incomestatement",
      "feesrecord",
      "classfees",
      "schoolfeedatachart",
      "feesrecordanalysics",
      "newexpenditure",
      "dailytransaction",
      "studentpaymentistory",
      "financedashboard",
      "feesallocation",
      "otherfees",
      "cleararrears",
      "monthlyrecords",
      "loan",
      "payroll",
    ],
  },
  {
    key: "learners",
    title: "LEARNER MANAGEMENT",
    items: [
      "studentsadmission",
      "admissionlist",
      "promotion",
      "studentscertificate",
      "studentsidcards",
      "complaintunit",
      "statusrecord",
    ],
  },
  {
    key: "academic",
    title: "ACADEMIC ADMINISTRATION",
    items: [
      "curriculumadminupload",
      "allCurriculumlis",
      "viewcurriculums",
      "curriculumpost",
      "classviewlist",
      "subjectviewlist",
      "gradedistribution",
      "bulkgrades",
      "topstudents",
      "highaverages",
      "periodicreport",
      "reportcard",
    ],
  },
  {
    key: "faculty",
    title: "FACULTY & STAFF",
    items: [
      "schoolarchivedashboard",
      "teacherdata",
      "viewlessonplan",
      "supportstaff",
      "getteachernotes",
      "attendancerecord",
      "attendancedata",
    ],
  },
  {
    key: "learning",
    title: "TEACHING & LEARNING",
    items: [
      "testprint",
      "printtestbyclass",
      "testattachmentview",
      "studentsassignments",
      "studentsnotes",
    ],
  },
  {
    key: "security",
    title: "SECURITY & DEVICES",
    items: [
      "newblacklist",
      "teachersmartattendancedashboard",
      "teacherattendancescanner",
      "teachersmartcardmanagement",
      "teacherscannerdevicemanagement",
    ],
  },
  {
    key: "administration",
    title: "SYSTEM ADMINISTRATION",
    items: [
      "systemusers",
      "curriculumadminupload",
      "settings",
    ],
  },
];

/* ============================================================
   DASHBOARD
============================================================ */

const NewVpaDashboard = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const [activePage, setActivePage] = useState("overview");
  const [selectedUser, setSelectedUser] = useState(null);
  const [menuSearch, setMenuSearch] = useState("");
  const [todoOpen, setTodoOpen] = useState(false);

  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined"
      ? window.innerWidth < 900
      : false
  );

  const [isNavigating, setIsNavigating] =
    useState(false);

  const [pendingPage, setPendingPage] =
    useState(null);

  const [openAcademyYear, setOpenAcademyYear] =
    useState(false);

  const [openGradePublication, setOpenGradePublication] =
    useState(false);

  const [academyYearRefreshing, setAcademyYearRefreshing] =
    useState(false);

  /* ==========================================================
     RESPONSIVE HANDLING
  ========================================================== */

  useEffect(() => {
    const handleResize = () => {
      const mobile =
        window.innerWidth < 900;

      setIsMobile(mobile);

      if (mobile) {
        setCollapsed(false);
      }
    };

    handleResize();

    window.addEventListener(
      "resize",
      handleResize
    );

    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );
    };
  }, []);

  /* ==========================================================
     DASHBOARD GLOBAL STYLES
  ========================================================== */

 
useEffect(() => {
  const style = document.createElement("style");

  style.id = "college-leadership-dashboard-styles";

  style.innerHTML = `
    * {
      box-sizing: border-box;
    }

    html,
    body,
    #root {
      margin: 0;
      min-height: 100%;
    }

    body {
      overflow: hidden;
    }

    /* ======================================================
       GLOBAL SCROLLBARS
       Gold normally, bright light blue on hover
    ====================================================== */

    :root {
      --college-scrollbar-size: 16px;
      --college-scrollbar-track: #031B35;
      --college-scrollbar-thumb: #F6C944;
      --college-scrollbar-hover: #75CFFF;
      --college-scrollbar-active: #0EA5E9;
    }

    * {
      scrollbar-width: auto;
      scrollbar-color: #F6C944 #031B35;
    }

    ::-webkit-scrollbar {
      width: 16px;
      height: 16px;
    }

    ::-webkit-scrollbar-track {
      background: #031B35;
      border-radius: 20px;
      border: 2px solid #062A4B;
    }

    ::-webkit-scrollbar-thumb {
      min-height: 50px;
      border-radius: 20px;
      border: 3px solid #031B35;

      background: linear-gradient(
        180deg,
        #FFE58A 0%,
        #F6C944 45%,
        #CBA454 75%,
        #C0750D 100%
      );

      background-clip: padding-box;

      box-shadow:
        inset 0 0 0 1px rgba(255, 255, 255, 0.18),
        0 0 7px rgba(246, 201, 68, 0.15);

      transition:
        background 0.2s ease,
        box-shadow 0.2s ease;
    }

    /* Bright blue hover for every dashboard scrollbar */
    ::-webkit-scrollbar-thumb:hover {
      background: linear-gradient(
        180deg,
        #E0F7FF 0%,
        #8EDCFF 35%,
        #38BDF8 70%,
        #0EA5E9 100%
      ) !important;

      background-clip: padding-box;

      border: 2px solid #062A4B;

      box-shadow:
        inset 0 0 0 1px rgba(255, 255, 255, 0.65),
        0 0 12px rgba(56, 189, 248, 0.65),
        0 0 22px rgba(14, 165, 233, 0.35);
    }

    ::-webkit-scrollbar-thumb:active {
      background: #0EA5E9 !important;
      background-clip: padding-box;
    }

    ::-webkit-scrollbar-corner {
      background: #031B35;
    }

    /* ======================================================
       SIDEBAR
    ====================================================== */

    .college-sidebar-shell {
      position: relative;
      height: 100%;
      min-height: 100vh;
      overflow: hidden;
      isolation: isolate;

      background: linear-gradient(
        155deg,
        #021426 0%,
        #031B35 28%,
        #062A4B 55%,
        #031B35 78%,
        #010D1A 100%
      );
    }

    .college-sidebar-shell::before {
      content: "";
      position: absolute;
      width: 420px;
      height: 420px;
      top: -180px;
      left: -210px;
      border-radius: 50%;

      background: radial-gradient(
        circle,
        rgba(15, 109, 171, 0.26) 0%,
        rgba(15, 109, 171, 0.08) 38%,
        transparent 72%
      );

      filter: blur(2px);
      pointer-events: none;
      z-index: -1;

      animation:
        collegeSidebarGlowOne
        12s ease-in-out infinite alternate;
    }

    .college-sidebar-shell::after {
      content: "";
      position: absolute;
      width: 390px;
      height: 390px;
      right: -250px;
      bottom: -160px;
      border-radius: 50%;

      background: radial-gradient(
        circle,
        rgba(246, 201, 68, 0.15) 0%,
        rgba(192, 117, 13, 0.07) 32%,
        transparent 72%
      );

      pointer-events: none;
      z-index: -1;

      animation:
        collegeSidebarGlowTwo
        15s ease-in-out infinite alternate;
    }

    @keyframes collegeSidebarGlowOne {
      0% {
        transform: translate3d(0, 0, 0) scale(1);
        opacity: 0.7;
      }

      50% {
        transform: translate3d(45px, 35px, 0) scale(1.08);
        opacity: 1;
      }

      100% {
        transform: translate3d(10px, 65px, 0) scale(0.95);
        opacity: 0.72;
      }
    }

    @keyframes collegeSidebarGlowTwo {
      0% {
        transform: translate3d(0, 0, 0) scale(1);
      }

      50% {
        transform: translate3d(-35px, -35px, 0) scale(1.1);
      }

      100% {
        transform: translate3d(-10px, -70px, 0) scale(0.94);
      }
    }

    .college-sidebar-grid {
      position: absolute;
      inset: 0;
      pointer-events: none;
      opacity: 0.035;

      background-image:
        linear-gradient(
          rgba(255, 255, 255, 0.5) 1px,
          transparent 1px
        ),
        linear-gradient(
          90deg,
          rgba(255, 255, 255, 0.5) 1px,
          transparent 1px
        );

      background-size: 34px 34px;

      mask-image: linear-gradient(
        to bottom,
        black,
        transparent 85%
      );

      z-index: -1;
    }

    .college-sidebar-brand {
      position: relative;
      height: 74px;
      min-height: 74px;

      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 11px;

      padding: 0 18px;

      border-bottom: 1px solid rgba(255, 255, 255, 0.075);

      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0.035),
        transparent
      );
    }

    .college-sidebar-brand::after {
      content: "";
      position: absolute;
      left: 18px;
      right: 18px;
      bottom: 0;
      height: 1px;

      background: linear-gradient(
        90deg,
        transparent,
        rgba(246, 201, 68, 0.7),
        transparent
      );

      opacity: 0.45;
    }

    .college-logo-box {
      position: relative;
      width: 40px;
      height: 40px;
      min-width: 40px;
      padding: 2px;

      border-radius: 10px;

      background: linear-gradient(
        145deg,
        #FFFFFF,
        #F6C944
      );

      display: flex;
      align-items: center;
      justify-content: center;

      box-shadow:
        0 7px 22px rgba(0, 0, 0, 0.28),
        0 0 0 1px rgba(246, 201, 68, 0.18);
    }

    .college-logo-box::before {
      content: "";
      position: absolute;
      inset: -4px;
      border-radius: 13px;
      border: 1px solid rgba(246, 201, 68, 0.15);

      animation:
        collegeLogoPulse
        3.5s ease-in-out infinite;
    }

    @keyframes collegeLogoPulse {
      0%,
      100% {
        opacity: 0.25;
        transform: scale(0.98);
      }

      50% {
        opacity: 0.8;
        transform: scale(1.04);
      }
    }

    .college-logo-box img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 8px;
      display: block;
    }

    .college-brand-name {
      color: #FFFFFF;
      font-size: 13px;
      font-weight: 800;
      line-height: 1.15;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .college-brand-subtitle {
      margin-top: 4px;
      color: #F6C944;
      font-size: 8px;
      font-weight: 850;
      letter-spacing: 1.3px;
    }

    /* ======================================================
       SIDEBAR SEARCH
    ====================================================== */

    .college-sidebar-search {
      position: relative;
      z-index: 2;
    }

    .college-sidebar-search .ant-input-affix-wrapper {
      min-height: 40px !important;
      border-radius: 10px !important;

      background: rgba(255, 255, 255, 0.055) !important;

      border: 1px solid rgba(255, 255, 255, 0.11) !important;

      box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.035),
        0 7px 20px rgba(0, 0, 0, 0.08) !important;

      transition: all 0.22s ease !important;
    }

    .college-sidebar-search .ant-input-affix-wrapper:hover {
      background: rgba(255, 255, 255, 0.075) !important;
      border-color: rgba(246, 201, 68, 0.35) !important;
    }

    .college-sidebar-search .ant-input-affix-wrapper-focused {
      border-color: rgba(246, 201, 68, 0.75) !important;
      background: rgba(255, 255, 255, 0.085) !important;

      box-shadow:
        0 0 0 3px rgba(246, 201, 68, 0.075),
        0 10px 24px rgba(0, 0, 0, 0.15) !important;
    }

    .college-sidebar-search .ant-input {
      background: transparent !important;
      color: #FFFFFF !important;
      font-size: 12px !important;
    }

    .college-sidebar-search .ant-input::placeholder {
      color: #8398AA !important;
    }

    /* ======================================================
       SIDEBAR SCROLLBAR
       Extra-wide gold scrollbar with bright blue hover
    ====================================================== */

    .college-sidebar-scroll {
      min-height: 0;
      overflow-y: auto !important;
      overflow-x: hidden !important;

      scrollbar-width: auto !important;
      scrollbar-color: #F6C944 #031B35 !important;

      overscroll-behavior-y: contain;
    }

    .college-sidebar-scroll::-webkit-scrollbar {
      width: 18px;
      height: 18px;
    }

    .college-sidebar-scroll::-webkit-scrollbar-track {
      background: #031B35;
      border-radius: 20px;
      border: 2px solid #062A4B;
    }

    .college-sidebar-scroll::-webkit-scrollbar-thumb {
      min-height: 55px;

      background: linear-gradient(
        180deg,
        #FFE58A 0%,
        #F6C944 45%,
        #CBA454 75%,
        #C0750D 100%
      );

      border-radius: 20px;
      border: 3px solid #031B35;
      background-clip: padding-box;

      box-shadow:
        inset 0 0 0 1px rgba(255, 255, 255, 0.18),
        0 0 7px rgba(246, 201, 68, 0.15);

      transition:
        background 0.2s ease,
        box-shadow 0.2s ease;
    }

    /* Extra-visible LIGHT BLUE sidebar hover */
    .college-sidebar-scroll::-webkit-scrollbar-thumb:hover {
      background: linear-gradient(
        180deg,
        #F0FCFF 0%,
        #BAEFFF 25%,
        #75CFFF 55%,
        #38BDF8 80%,
        #0284C7 100%
      ) !important;

      background-clip: padding-box;

      border: 2px solid #031B35;

      box-shadow:
        inset 0 0 0 1px rgba(255, 255, 255, 0.8),
        0 0 14px rgba(117, 207, 255, 0.8),
        0 0 26px rgba(56, 189, 248, 0.45);
    }

    .college-sidebar-scroll::-webkit-scrollbar-thumb:active {
      background: #0EA5E9 !important;
      background-clip: padding-box;
    }

    .college-sidebar-scroll::-webkit-scrollbar-corner {
      background: #031B35;
    }

    /* ======================================================
       SIDEBAR SECTION TITLES
    ====================================================== */

    .college-section-title {
      position: relative;
      padding: 17px 19px 7px;
      color: #748DA1;
      font-size: 8.5px;
      font-weight: 850;
      letter-spacing: 1.35px;
      user-select: none;
    }

    .college-section-title::before {
      content: "";
      display: inline-block;
      width: 16px;
      height: 1px;
      margin: 0 7px 3px 0;

      background: linear-gradient(
        90deg,
        #CBA454,
        transparent
      );

      opacity: 0.7;
    }

    /* ======================================================
       NAVIGATION ITEMS
    ====================================================== */

    .college-nav-item {
      position: relative;
      width: calc(100% - 20px);
      min-height: 44px;
      margin: 3px 10px;
      padding: 0 11px;

      border: 1px solid transparent;
      border-radius: 10px;

      display: flex;
      align-items: center;
      gap: 11px;

      color: #AEBFCD;
      background: transparent;

      cursor: pointer;
      text-align: left;
      font-family: inherit;
      font-size: 12.5px;
      font-weight: 520;

      overflow: hidden;

      transition:
        background 0.22s ease,
        color 0.22s ease,
        border-color 0.22s ease,
        transform 0.22s ease,
        box-shadow 0.22s ease;
    }

    .college-nav-item:disabled {
      cursor: wait;
      opacity: 0.72;
    }

    .college-nav-item::after {
      content: "";
      position: absolute;
      inset: 0;

      background: linear-gradient(
        100deg,
        transparent 20%,
        rgba(255, 255, 255, 0.055) 50%,
        transparent 80%
      );

      transform: translateX(-110%);
      transition: transform 0.55s ease;
      pointer-events: none;
    }

    .college-nav-item:hover::after {
      transform: translateX(110%);
    }

    .college-nav-item:hover {
      color: #FFFFFF;

      background: linear-gradient(
        90deg,
        rgba(15, 109, 171, 0.22),
        rgba(255, 255, 255, 0.045)
      );

      border-color: rgba(255, 255, 255, 0.07);
      transform: translateX(2px);

      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
    }

    .college-nav-item:hover .college-nav-icon {
      color: #F6C944;
      border-color: rgba(246, 201, 68, 0.30);
      background: rgba(246, 201, 68, 0.075);
      transform: scale(1.05);
    }

    .college-nav-item.active {
      color: #FFFFFF;
      font-weight: 700;

      background: linear-gradient(
        105deg,
        #0F6DAB 0%,
        #095A91 48%,
        #063A6B 100%
      );

      border-color: rgba(246, 201, 68, 0.17);

      box-shadow:
        0 9px 24px rgba(0, 0, 0, 0.18),
        inset 0 1px 0 rgba(255, 255, 255, 0.08);

      transform: translateX(2px);
    }

    .college-nav-item.active::before {
      content: "";
      position: absolute;
      left: 0;
      top: 7px;
      bottom: 7px;
      width: 3px;

      border-radius: 0 4px 4px 0;

      background: linear-gradient(
        180deg,
        #FFE58A,
        #F6C944,
        #C0750D
      );

      box-shadow: 0 0 12px rgba(246, 201, 68, 0.65);
    }

    .college-nav-item.active .college-nav-icon {
      color: #F6C944;
      border-color: rgba(246, 201, 68, 0.32);
      background: rgba(246, 201, 68, 0.10);
      box-shadow: 0 0 15px rgba(246, 201, 68, 0.08);
    }

    .college-nav-icon {
      width: 29px;
      height: 29px;
      min-width: 29px;

      display: flex;
      align-items: center;
      justify-content: center;

      border-radius: 8px;
      color: #8098AA;
      border: 1px solid transparent;
      font-size: 14px;

      transition: all 0.22s ease;
    }

    .college-nav-label {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      line-height: 1.2;
    }

    .college-nav-chevron {
      margin-left: auto;
      opacity: 0;
      transform: translateX(-5px);
      transition: all 0.22s ease;
      color: #F6C944;
      font-size: 12px;
    }

    .college-nav-item:hover .college-nav-chevron,
    .college-nav-item.active .college-nav-chevron {
      opacity: 0.95;
      transform: translateX(0);
    }

    .college-collapsed-item {
      width: calc(100% - 16px);
      justify-content: center;
      margin-left: 8px;
      margin-right: 8px;
      padding: 0;
    }

    .college-collapsed-item:hover,
    .college-collapsed-item.active {
      transform: translateX(0);
    }

    .college-collapsed-item .college-nav-chevron,
    .college-collapsed-item .college-nav-label {
      display: none;
    }

    .college-collapsed-item .college-nav-icon {
      width: 36px;
      height: 36px;
      min-width: 36px;
      font-size: 15px;
    }

    /* ======================================================
       HEADER MENU BUTTON
    ====================================================== */

    .college-menu-button {
      width: 39px !important;
      height: 39px !important;
      min-width: 39px !important;
      padding: 0 !important;

      display: flex !important;
      align-items: center !important;
      justify-content: center !important;

      border: 1px solid #DCE3E8 !important;
      border-radius: 10px !important;
      background: #FFFFFF !important;
      color: #063A6B !important;

      box-shadow: 0 3px 10px rgba(6, 42, 75, 0.04) !important;
      transition: all 0.2s ease !important;
    }

    .college-menu-button:hover {
      color: #C0750D !important;
      border-color: #CBA454 !important;
      background: #FFFCF4 !important;
      transform: translateY(-1px);
    }

    .college-dark .college-menu-button {
      background: #10222F !important;
      border-color: #29404F !important;
      color: #F0EDEA !important;
    }

    /* ======================================================
       HEADER SEARCH
    ====================================================== */

    .college-search-box .ant-input-affix-wrapper {
      min-height: 39px !important;
      border-radius: 10px !important;
      border: 1px solid #DCE3E8 !important;
      background: #FFFFFF !important;
      box-shadow: none !important;
      transition: all 0.2s ease !important;
    }

    .college-search-box .ant-input-affix-wrapper:hover {
      border-color: #CBA454 !important;
    }

    .college-search-box .ant-input-affix-wrapper-focused {
      border-color: #0F6DAB !important;

      box-shadow:
        0 0 0 3px rgba(15, 109, 171, 0.08) !important;
    }

    .college-dark .college-search-box .ant-input-affix-wrapper {
      background: #10222F !important;
      border-color: #29404F !important;
    }

    /* ======================================================
       HEADER ACTION BUTTONS
    ====================================================== */

    .college-header-action {
      width: 39px;
      height: 39px;
      min-width: 39px;
      padding: 0;

      border-radius: 10px;
      border: 1px solid #DCE3E8;

      background: #FFFFFF;
      color: #063A6B;

      display: flex;
      align-items: center;
      justify-content: center;

      cursor: pointer;
      transition: all 0.2s ease;
    }

    .college-header-action:hover {
      color: #C0750D;
      border-color: #CBA454;
      background: #FFFCF4;
      transform: translateY(-1px);
    }

    .college-dark .college-header-action {
      background: #10222F;
      border-color: #29404F;
      color: #F0EDEA;
    }

    /* ======================================================
       HEADER ADMIN ACTIONS
    ====================================================== */

    .college-header-admin-action {
      position: relative;
      width: 39px;
      height: 39px;
      min-width: 39px;
      padding: 0;

      border-radius: 10px;
      border: 1px solid #DCE3E8;

      background: #FFFFFF;
      color: #063A6B;

      display: flex;
      align-items: center;
      justify-content: center;

      cursor: pointer;
      transition: all 0.2s ease;
    }

    .college-header-admin-action:hover {
      color: #800000;
      border-color: #CBA454;
      background: #FFFCF4;
      transform: translateY(-1px);

      box-shadow: 0 6px 16px rgba(128, 0, 0, 0.08);
    }

    .college-header-admin-action.publication:hover {
      color: #800000;
    }

    .college-header-admin-action.chat:hover {
      color: #0F6DAB;

      box-shadow: 0 6px 16px rgba(15, 109, 171, 0.10);
    }

    .college-header-admin-action::after {
      content: "";
      position: absolute;
      right: 6px;
      top: 6px;
      width: 5px;
      height: 5px;
      border-radius: 50%;

      background: #F6C944;

      box-shadow: 0 0 0 3px rgba(246, 201, 68, 0.10);
    }

    .college-header-admin-action.chat::after {
      background: #4FAE22;

      box-shadow: 0 0 0 3px rgba(79, 174, 34, 0.10);
    }

    .college-dark .college-header-admin-action {
      background: #10222F;
      border-color: #29404F;
      color: #F0EDEA;
    }

    .college-dark .college-header-admin-action:hover {
      background: #162D3D;
    }

    /* ======================================================
       ACADEMIC YEAR BUTTON
    ====================================================== */

    .college-academic-year {
      height: 39px;
      padding: 0 13px;

      border-radius: 10px;
      border: 1px solid #D7E0E6;

      background: #FFFFFF;
      color: #063A6B;

      display: flex;
      align-items: center;
      gap: 7px;

      cursor: pointer;
      font-size: 11px;
      font-weight: 750;
      white-space: nowrap;

      transition: all 0.2s ease;
    }

    .college-academic-year:hover {
      color: #C0750D;
      border-color: #CBA454;
      background: #FFFCF4;
      transform: translateY(-1px);

      box-shadow: 0 5px 15px rgba(192, 117, 13, 0.08);
    }

    .college-academic-year:disabled {
      opacity: 0.65;
      cursor: wait;
      transform: none;
    }

    .college-dark .college-academic-year {
      background: #10222F;
      border-color: #29404F;
      color: #F0EDEA;
    }

    /* ======================================================
       PROFILE
    ====================================================== */

    .college-profile-container {
      width: 42px;
      height: 42px;
      min-width: 42px;
      padding: 2px;

      border-radius: 50%;

      background: linear-gradient(
        135deg,
        #F6C944,
        #CBA454,
        #063A6B
      );

      display: flex;
      align-items: center;
      justify-content: center;

      box-shadow: 0 4px 15px rgba(6, 42, 75, 0.13);

      transition:
        transform 0.2s ease,
        box-shadow 0.2s ease;
    }

    .college-profile-container:hover {
      transform: translateY(-1px) scale(1.03);
      box-shadow: 0 7px 20px rgba(6, 42, 75, 0.18);
    }

    .college-profile-avatar {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      overflow: hidden;
      background: #FFFFFF;

      display: flex;
      align-items: center;
      justify-content: center;
    }

    .college-profile-avatar > * {
      width: 100% !important;
      height: 100% !important;
      min-width: 0 !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;

      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    .college-profile-avatar img {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
      object-position: center !important;
      display: block !important;
    }

    /* ======================================================
       WORKSPACE
    ====================================================== */

    .college-workspace {
      position: relative;

      border: 1px solid #E0E7EC;
      background: #FFFFFF;
      border-radius: 13px;

      min-height: calc(100vh - 111px);

      box-shadow: 0 5px 22px rgba(6, 42, 75, 0.045);

      overflow: hidden;
    }

    .college-workspace::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 2px;

      background: linear-gradient(
        90deg,
        transparent,
        #CBA454,
        #F6C944,
        #0F6DAB,
        transparent
      );

      opacity: 0.42;
    }

    .college-workspace-dark {
      background: #10222F;
      border-color: #29404F;
    }

    /* ======================================================
       PAGE HEADING
    ====================================================== */

    .college-page-heading {
      min-height: 34px;

      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;

      margin-bottom: 8px;
      padding: 0 2px;
    }

    .college-page-heading-left {
      min-width: 0;

      display: flex;
      align-items: center;
      gap: 9px;
    }

    .college-page-heading-line {
      width: 4px;
      height: 19px;
      min-width: 4px;
      border-radius: 3px;

      background: linear-gradient(
        180deg,
        #F6C944,
        #C0750D
      );

      box-shadow: 0 0 10px rgba(246, 201, 68, 0.18);
    }

    .college-page-heading-title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      color: #142536;
      font-size: 14px;
      font-weight: 780;
    }

    .college-dark .college-page-heading-title {
      color: #F0EDEA;
    }

    .college-page-heading-meta {
      color: #6B7280;
      font-size: 10px;
      white-space: nowrap;
    }

    .college-dark .college-page-heading-meta {
      color: #A8B6C0;
    }

    /* ======================================================
       NAVIGATION PROGRESS
    ====================================================== */

    .college-navigation-progress {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      z-index: 1000;
      overflow: hidden;

      background: rgba(192, 117, 13, 0.12);
    }

    .college-navigation-progress::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      height: 100%;

      background: linear-gradient(
        90deg,
        #C0750D,
        #F6C944,
        #0F6DAB
      );

      box-shadow: 0 0 10px rgba(246, 201, 68, 0.65);

      animation:
        collegeNavigationProgress
        2s linear forwards;
    }

    @keyframes collegeNavigationProgress {
      0% {
        width: 0%;
      }

      20% {
        width: 24%;
      }

      45% {
        width: 51%;
      }

      70% {
        width: 72%;
      }

      90% {
        width: 91%;
      }

      100% {
        width: 100%;
      }
    }

    .college-loading-label {
      position: absolute;
      top: 10px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1001;

      padding: 5px 11px;
      border-radius: 7px;

      background: linear-gradient(
        135deg,
        rgba(3, 27, 53, 0.97),
        rgba(6, 58, 107, 0.97)
      );

      color: #FFFFFF;
      font-size: 9px;
      font-weight: 750;
      letter-spacing: 0.7px;
      text-transform: uppercase;
      white-space: nowrap;

      box-shadow: 0 7px 20px rgba(0, 0, 0, 0.14);

      border: 1px solid rgba(246, 201, 68, 0.17);
    }

    /* ======================================================
       MOBILE RESPONSIVENESS
    ====================================================== */

    @media (max-width: 899px) {
      .college-academic-year {
        width: 36px;
        min-width: 36px;
        padding: 0;
        justify-content: center;
      }

      .college-academic-year-text {
        display: none;
      }

      .college-header-admin-action,
      .college-header-action {
        width: 36px;
        height: 36px;
        min-width: 36px;
      }

      .college-profile-container {
        width: 37px;
        height: 37px;
        min-width: 37px;
      }

      .college-workspace {
        min-height: calc(100vh - 96px);
        border-radius: 9px;
      }

      .college-page-heading {
        min-height: 30px;
      }

      .college-page-heading-title {
        font-size: 13px;
      }

      .college-page-heading-meta {
        display: none;
      }
    }

    @media (max-width: 560px) {
      .college-header-admin-action {
        width: 34px;
        height: 34px;
        min-width: 34px;
        border-radius: 9px;
      }

      .college-header-admin-action .anticon {
        font-size: 14px;
      }

      .college-header-action {
        width: 34px;
        height: 34px;
        min-width: 34px;
      }

      .college-menu-button {
        width: 36px !important;
        height: 36px !important;
        min-width: 36px !important;
      }

      .college-profile-container {
        width: 35px;
        height: 35px;
        min-width: 35px;
      }

      .college-workspace {
        border-left: 0;
        border-right: 0;
        box-shadow: none;
      }

      .college-sidebar-scroll::-webkit-scrollbar {
        width: 18px;
      }
    }

    /* ======================================================
       REDUCED MOTION
    ====================================================== */

    @media (prefers-reduced-motion: reduce) {
      .college-sidebar-shell::before,
      .college-sidebar-shell::after,
      .college-logo-box::before,
      .college-navigation-progress::after {
        animation: none !important;
      }

      .college-nav-item,
      .college-nav-icon,
      .college-header-action,
      .college-header-admin-action,
      .college-menu-button,
      .college-profile-container,
      ::-webkit-scrollbar-thumb {
        transition: none !important;
      }
    }
  `;

  /* Remove any previous copy before inserting the updated styles. */
  const existing = document.getElementById(
    "college-leadership-dashboard-styles"
  );

  if (existing) {
    existing.remove();
  }

  document.head.appendChild(style);

  return () => {
    const current = document.getElementById(
      "college-leadership-dashboard-styles"
    );

    if (current) {
      current.remove();
    }
  };
}, []);

  

  /* ==========================================================
     THEME
  ========================================================== */

  const theme = useMemo(
    () => ({
      darkMode,

      background: darkMode
        ? "#08151F"
        : COLORS.page,

      sidebar: COLORS.deepNavy,

      header: darkMode
        ? "#0B1A25"
        : COLORS.pureWhite,

      card: darkMode
        ? "#10222F"
        : COLORS.pureWhite,

      inputBackground: darkMode
        ? "#10222F"
        : COLORS.pureWhite,

      text: darkMode
        ? "#F0EDEA"
        : COLORS.text,

      secondary: darkMode
        ? "#A8B6C0"
        : COLORS.muted,

      border: darkMode
        ? "#29404F"
        : COLORS.border,

      primary: COLORS.blue,
      navy: COLORS.navy,
      blue: COLORS.blue,
      gold: COLORS.gold,
      yellow: COLORS.yellow,
      orange: COLORS.orange,
      green: COLORS.green,
      sky: COLORS.sky,
      antique: COLORS.antique,
    }),
    [darkMode]
  );

  /* ==========================================================
     MENU LOOKUP
  ========================================================== */

  const menuLookup = useMemo(
    () =>
      Object.fromEntries(
        menuItems.map((item) => [
          item.key,
          item,
        ])
      ),
    []
  );

  /* ==========================================================
     FILTERED NAVIGATION
  ========================================================== */

  const filteredSections = useMemo(() => {
    const query = menuSearch
      .trim()
      .toLowerCase();

    if (!query) {
      return navigationSections;
    }

    return navigationSections
      .map((section) => ({
        ...section,
        items: section.items.filter(
          (key) =>
            menuLookup[key]?.label
              ?.toLowerCase()
              .includes(query)
        ),
      }))
      .filter(
        (section) =>
          section.items.length > 0
      );
  }, [menuSearch, menuLookup]);

  /* ==========================================================
     ACTIVE TITLE
  ========================================================== */

  const activeTitle =
    selectedUser
      ? "User Details"
      : menuLookup[activePage]?.label ||
        "Dashboard";

  /* ==========================================================
     ACADEMIC YEAR REFRESH
  ========================================================== */

  const fetchAcademicYears = async () => {
    setAcademyYearRefreshing(true);

    try {
      window.dispatchEvent(
        new Event(
          "academicYearUpdated"
        )
      );

      window.dispatchEvent(
        new Event(
          "academic-year-updated"
        )
      );
    } finally {
      setTimeout(() => {
        setAcademyYearRefreshing(false);
      }, 400);
    }
  };

  /* ==========================================================
     CHAT NAVIGATION
  ========================================================== */

  const openSchoolMembersChat = () => {
    window.location.href = "/chatApp";
  };

  /* ==========================================================
     PAGE RENDERING
  ========================================================== */

  const renderPage = () => {
    if (selectedUser) {
      return (
        <UserDetailsPage
          theme={theme}
          selectedUser={selectedUser}
        />
      );
    }

    switch (activePage) {
      case "payroll":
        return <Payroll theme={theme} />;

      case "dailytransaction":
        return (
          <DailyPaymentTransactionUpdate
            theme={theme}
          />
        );

      case "studentpaymentistory":
        return (
          <StudentPaymentHistory
            theme={theme}
          />
        );

      case "incomestatement":
        return (
          <IncomeStatement
            theme={theme}
          />
        );

      case "systemusers":
        return (
          <AddStudentsStaff
            theme={theme}
          />
        );

      case "studentsadmission":
        return (
          <AdmissionForm
            theme={theme}
          />
        );

      case "admissionlist":
        return (
          <StudentAdmission
            theme={theme}
          />
        );

      case "gradedistribution":
        return (
          <GradeDistribution
            theme={theme}
          />
        );

      case "promotion":
        return (
          <PromotionDashboard
            theme={theme}
          />
        );

      case "studentscertificate":
        return (
          <CertificateDashboard
            theme={theme}
          />
        );

      case "studentsidcards":
        return (
          <StudentsIDCard
            theme={theme}
          />
        );

      case "complaintunit":
        return (
          <ComplaintUnit
            theme={theme}
          />
        );



      case "viewlessonplan":
        return (
          <ViewLessonPlan
            theme={theme}
          />
        );

      case "supportstaff":
        return (
          <SupportStaff
            theme={theme}
          />
        );

      case "testprint":
        return (
          <TestPraint
            theme={theme}
          />
        );

      case "printtestbyclass":
        return (
          <PrintTestByClass
            theme={theme}
          />
        );

      case "schoolarchivedashboard":
        return (
          <SchoolArchiveDashboard
            theme={theme}
          />
        );

      case "getteachernotes":
        return (
          <GetStudentNotes
            theme={theme}
          />
        );

      case "testattachmentview":
        return (
          <TestAttachmentView
            theme={theme}
          />
        );

      case "curriculumadminupload":
        return (
          <CurriculumAdminUpload
            theme={theme}
          />
        );

      case "allCurriculumlis":
        return (
          <AllCurriculumLis
            theme={theme}
          />
        );

      case "curriculumpost":
        return (
          <CurriculumPost
            theme={theme}
          />
        );

      case "viewcurriculums":
        return (
          <ViewCurriculums
            theme={theme}
          />
        );

      case "attendancerecord":
        return (
          <AttendanceRecord
            theme={theme}
          />
        );

      case "attendancedata":
        return (
          <AttendanceData
            theme={theme}
          />
        );

      case "statusrecord":
        return (
          <StudentStatusSummary
            theme={theme}
          />
        );

      case "financedashboard":
        return (
          <FinanceDashboard
            theme={theme}
          />
        );

      case "highaverages":
        return (
          <HighAveragesPage
            theme={theme}
          />
        );

      case "topstudents":
        return (
          <TopStudentPerPeriod
            theme={theme}
          />
        );

      case "classviewlist":
        return (
          <ClassViewList
            theme={theme}
          />
        );

      case "subjectviewlist":
        return (
          <SubjectViewList
            theme={theme}
          />
        );

      case "periodicreport":
        return (
          <PeriodReport
            theme={theme}
          />
        );

      case "reportcard":
        return (
          <ReportCard
            theme={theme}
          />
        );

      case "studentsassignments":
        return (
          <AssignmentView
            theme={theme}
          />
        );

      case "studentsnotes":
        return (
          <GetStudentNotes
            theme={theme}
          />
        );

      case "feesrecord":
        return (
          <FinancialPaymentRecord
            theme={theme}
          />
        );

      case "feesrecordanalysics":
        return (
          <SchoolFinancialReport
            theme={theme}
          />
        );

      case "newexpenditure":
        return (
          <DashboardForExpenditure
            theme={theme}
          />
        );

      case "feesallocation":
        return (
          <OtherFee
            theme={theme}
          />
        );

      case "cleararrears":
        return (
          <PaymentRecord
            theme={theme}
          />
        );

      case "classfees":
        return (
          <SchoolFeesData
            theme={theme}
          />
        );

      case "schoolfeedatachart":
        return (
          <SchoolFeeDataChart
            theme={theme}
          />
        );

      case "otherfees":
        return (
          <OtherFeesPayment
            theme={theme}
          />
        );

      case "monthlyrecords":
        return (
          <MonthlyFinancialRecord
            theme={theme}
          />
        );

      case "newblacklist":
        return (
          <NewBlackList
            theme={theme}
          />
        );

      case "loan":
        return <Loan theme={theme} />;

      case "bulkgrades":
        return (
          <BulkTestScorePage
            theme={theme}
          />
        );

      case "teacherattendancescanner":
        return (
          <TeacherAttendanceScanner
            theme={theme}
          />
        );

      case "teachersmartattendancedashboard":
        return (
          <TeacherSmartAttendanceDashboard
            theme={theme}
          />
        );

      case "teachersmartcardmanagement":
        return (
          <TeacherSmartCardManagement
            theme={theme}
          />
        );

      case "teacherscannerdevicemanagement":
        return (
          <TeacherScannerDeviceManagement
            theme={theme}
          />
        );

      default:
        return (
          <OverviewVpi
            theme={theme}
          />
        );
    }
  };

  /* ==========================================================
     NAVIGATION
  ========================================================== */

  const handleNavigation = (key) => {
    if (isNavigating) {
      return;
    }

    if (
      key === activePage &&
      !selectedUser
    ) {
      if (isMobile) {
        setDrawerOpen(false);
      }

      return;
    }

    setPendingPage(key);
    setIsNavigating(true);
    setSelectedUser(null);
    setMenuSearch("");

    if (isMobile) {
      setDrawerOpen(false);
    }

    window.setTimeout(() => {
      setActivePage(key);
      setPendingPage(null);
      setIsNavigating(false);
    }, 2000);
  };

  /* ==========================================================
     NAVIGATION ITEM
  ========================================================== */

  const renderNavigationItem = (item) => {
    const active =
      activePage === item.key &&
      !selectedUser;

    return (
      <Tooltip
        key={item.key}
        title={
          collapsed
            ? item.label
            : ""
        }
        placement="right"
      >
        <button
          type="button"
          className={[
            "college-nav-item",
            active
              ? "active"
              : "",
            collapsed
              ? "college-collapsed-item"
              : "",
          ].join(" ")}
          onClick={() =>
            handleNavigation(
              item.key
            )
          }
          disabled={isNavigating}
          aria-current={
            active
              ? "page"
              : undefined
          }
        >
          <span className="college-nav-icon">
            {item.icon}
          </span>

          <span className="college-nav-label">
            {item.label}
          </span>

          <span className="college-nav-chevron">
            ›
          </span>
        </button>
      </Tooltip>
    );
  };

  /* ==========================================================
     SIDEBAR
  ========================================================== */

  const sidebar = (
    <div className="college-sidebar-shell">
      <div className="college-sidebar-grid" />

      <div
        style={{
          height: "100%",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* BRAND */}

        <div
          className="college-sidebar-brand"
          style={{
            justifyContent: collapsed
              ? "center"
              : "flex-start",
            padding: collapsed
              ? "0 10px"
              : "0 18px",
          }}
        >
          <div className="college-logo-box">
            <img
              src={logo}
              alt="Zion Praise Academy logo"
            />
          </div>

          {!collapsed && (
            <div
              style={{
                minWidth: 0,
              }}
            >
              <div className="college-brand-name">
                Zion Praise Academy
              </div>

              <div className="college-brand-subtitle">
                POLU SMS
              </div>
            </div>
          )}
        </div>

        {/* SEARCH */}

        {!collapsed && (
          <div
            className="college-sidebar-search"
            style={{
              padding:
                "14px 12px 7px",
              flexShrink: 0,
            }}
          >
            <Input
              allowClear
              value={menuSearch}
              onChange={(event) =>
                setMenuSearch(
                  event.target.value
                )
              }
              placeholder="Find a module..."
              prefix={
                <SearchOutlined
                  style={{
                    color:
                      COLORS.antique,
                  }}
                />
              }
            />
          </div>
        )}

        {/* NAVIGATION */}

        <div
          className="college-sidebar-scroll"
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            overflowX: "hidden",
            paddingBottom: 24,
          }}
        >
          {filteredSections.length ===
            0 && (
            <div
              style={{
                padding:
                  "35px 20px",
                textAlign:
                  "center",
                color:
                  "#8298AA",
                fontSize: 11,
              }}
            >
              No module found
            </div>
          )}

          {filteredSections.map(
            (section) => {
              const items =
                section.items
                  .map(
                    (key) =>
                      menuLookup[
                        key
                      ]
                  )
                  .filter(Boolean);

              if (!items.length) {
                return null;
              }

              return (
                <div
                  key={
                    section.key
                  }
                >
                  {!collapsed ? (
                    <div className="college-section-title">
                      {
                        section.title
                      }
                    </div>
                  ) : (
                    <div
                      style={{
                        height: 12,
                      }}
                    />
                  )}

                  {items.map(
                    renderNavigationItem
                  )}
                </div>
              );
            }
          )}
        </div>
      </div>
    </div>
  );

  /* ==========================================================
     MAIN
  ========================================================== */

  return (
    <div
      className={
        darkMode
          ? "college-dark"
          : ""
      }
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 999,
        overflow: "hidden",
        background:
          theme.background,
      }}
    >
      <Layout
        style={{
          height: "100vh",
          minHeight: "100vh",
          background:
            theme.background,
        }}
      >
        {/* ====================================================
            DESKTOP SIDEBAR
        ==================================================== */}

        {!isMobile && (
          <Sider
            width={292}
            collapsedWidth={78}
            collapsed={collapsed}
            trigger={null}
            style={{
              position: "fixed",
              top: 0,
              bottom: 0,
              left: 0,
              height: "100vh",
              zIndex: 100,
              overflow: "hidden",
              background:
                COLORS.deepNavy,
            }}
          >
            {sidebar}
          </Sider>
        )}

        {/* ====================================================
            MOBILE DRAWER
        ==================================================== */}

        {isMobile && (
          <Drawer
            open={drawerOpen}
            placement="left"
            width={310}
            closable={false}
            onClose={() =>
              setDrawerOpen(false)
            }
            styles={{
              body: {
                padding: 0,
                background:
                  COLORS.deepNavy,
              },
            }}
          >
            <div
              style={{
                position:
                  "absolute",
                top: 13,
                right: 13,
                zIndex: 20,
              }}
            >
              <Button
                type="text"
                icon={
                  <CloseOutlined />
                }
                onClick={() =>
                  setDrawerOpen(false)
                }
                style={{
                  width: 34,
                  height: 34,
                  color:
                    "#FFFFFF",
                  background:
                    "rgba(255,255,255,.08)",
                  borderRadius: 9,
                  display: "flex",
                  alignItems:
                    "center",
                  justifyContent:
                    "center",
                  border:
                    "1px solid rgba(255,255,255,.08)",
                }}
              />
            </div>

            {sidebar}
          </Drawer>
        )}

        {/* ====================================================
            MAIN LAYOUT
        ==================================================== */}

        <Layout
          style={{
            marginLeft: isMobile
              ? 0
              : collapsed
                ? 78
                : 292,
            height: "100vh",
            minHeight: "100vh",
            background:
              theme.background,
            transition:
              "margin-left 220ms cubic-bezier(.22,1,.36,1)",
          }}
        >
          {/* ==================================================
              HEADER
          ================================================== */}

          <Header
            style={{
              height: 68,
              minHeight: 68,
              flexShrink: 0,
              padding: isMobile
                ? "0 9px"
                : "0 16px",
              display: "flex",
              alignItems: "center",
              gap: isMobile
                ? 5
                : 10,
              background:
                theme.header,
              borderBottom:
                `1px solid ${theme.border}`,
              position: "relative",
              zIndex: 30,
            }}
          >
            {/* NAVIGATION LOADING */}

            {isNavigating && (
              <>
                <div className="college-navigation-progress" />

                <div className="college-loading-label">
                  Opening{" "}
                  {menuLookup[
                    pendingPage
                  ]?.label ||
                    "module"}
                </div>
              </>
            )}

            {/* MENU */}

            <Button
              type="text"
              className="college-menu-button"
              icon={
                isMobile ? (
                  <MenuUnfoldOutlined />
                ) : collapsed ? (
                  <MenuUnfoldOutlined />
                ) : (
                  <MenuFoldOutlined />
                )
              }
              onClick={() => {
                if (isMobile) {
                  setDrawerOpen(
                    true
                  );
                } else {
                  setCollapsed(
                    (value) =>
                      !value
                  );
                }
              }}
              aria-label={
                isMobile
                  ? "Open navigation menu"
                  : collapsed
                    ? "Expand sidebar"
                    : "Collapse sidebar"
              }
            />

   {/* User Search bar */}
            {/* <div
              className="college-search-box"
              style={{
                flex: 1,
                minWidth: 0,
                maxWidth:
                  isMobile
                    ? 270
                    : 450,
              }}
            >
              <UserSearchBox
                theme={theme}
                setSelectedUser={
                  setSelectedUser
                }
                setActiveComponent={
                  setActivePage
                }
              />
            </div> */}

            {/* HEADER SPACER */}

            <div
              style={{
                flex: 1,
                minWidth: 0,
              }}
            />


            {/* ==================================================
                GRADE PUBLICATION
            ================================================== */}

            <Tooltip title="Publish / Unpublish Grades">
              <button
                type="button"
                className="college-header-admin-action publication"
                onClick={() =>
                  setOpenGradePublication(
                    true
                  )
                }
                aria-label="Open Grade Publication Control"
              >
                <CloudUploadOutlined />
              </button>
            </Tooltip>

            {/* ==================================================
                SCHOOL MEMBERS CHAT
            ================================================== */}

            <Tooltip title="School Members Chat">
              <button
                type="button"
                className="college-header-admin-action chat"
                onClick={
                  openSchoolMembersChat
                }
                aria-label="Open School Members Chat"
              >
                <MessageOutlined />
              </button>
            </Tooltip>

            {/* ==================================================
                TASKS
            ================================================== */}

            <Tooltip title="Tasks">
              <button
                type="button"
                className="college-header-action"
                onClick={() =>
                  setTodoOpen(
                    true
                  )
                }
                aria-label="Open Tasks"
              >
                <CheckSquareOutlined />
              </button>
            </Tooltip>

            {/* TODO */}

            <PostTodoList
              open={todoOpen}
              setOpen={setTodoOpen}
            />

            {/* DARK MODE */}

            <Darkmode
              darkMode={darkMode}
              setDarkMode={
                setDarkMode
              }
            />

            {/* NOTIFICATIONS */}

            {!isMobile && (
              <>
                <NotificationIcon
                  theme={theme}
                />

                <Notice />
              </>
            )}

            {/* PROFILE */}

            <Tooltip title="Profile">
              <div className="college-profile-container">
                <div className="college-profile-avatar">
                  <ProfileImage
                    theme={theme}
                    header
                  />
                </div>
              </div>
            </Tooltip>
          </Header>

          {/* ==================================================
              CONTENT
          ================================================== */}

          <Content
            style={{
              background:
                theme.background,
              padding: isMobile
                ? "9px 8px 12px"
                : "14px 16px 18px",
              minHeight: 0,
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            {/* PAGE TITLE */}

            <div className="college-page-heading">
              <div className="college-page-heading-left">
                <span className="college-page-heading-line" />

                <span className="college-page-heading-title">
                  {activeTitle}
                </span>
              </div>

              {!isMobile && (
                <span className="college-page-heading-meta">
                  Zion Praise Academy
                </span>
              )}
            </div>

            {/* PAGE WORKSPACE */}

            <motion.div
              key={
                selectedUser
                  ? "user-details"
                  : activePage
              }
              initial={{
                opacity: 0,
                y: 7,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.24,
                ease: [
                  0.22,
                  1,
                  0.36,
                  1,
                ],
              }}
              className={
                darkMode
                  ? "college-workspace college-workspace-dark"
                  : "college-workspace"
              }
              style={{
                padding: isMobile
                  ? 9
                  : 15,
              }}
            >
              {renderPage()}
            </motion.div>
          </Content>
        </Layout>
      </Layout>

      {/* ======================================================
          ADD ACADEMIC YEAR
      ====================================================== */}

      <AddAcademyYear
        open={openAcademyYear}
        handleClose={() =>
          setOpenAcademyYear(
            false
          )
        }
        refreshYears={
          fetchAcademicYears
        }
      />

      {/* ======================================================
          GRADE PUBLICATION CONTROL
      ====================================================== */}

      <AdminPublishGradesPopup
        open={openGradePublication}
        onClose={() =>
          setOpenGradePublication(
            false
          )
        }
      />
    </div>
  );
};

export default NewVpaDashboard;
